import {
  BarChart3,
  type LucideIcon,
  Shield,
  TrendingUp,
  Zap,
} from "lucide-react";
import { useTranslations } from "next-intl";

interface Feature {
  icon: LucideIcon;
  title: string;
  description: string;
}

const iconMap = [TrendingUp, Zap, Shield, BarChart3];

export function FeatureCards() {
  const t = useTranslations();
  const features = t.raw("signUp.features");

  return (
    <div className="space-y-3">
      {features.map((feature: Feature, index: number) => {
        const Icon = iconMap[index];
        return (
          <div key={feature.title} className="flex gap-4 items-start">
            <div className="flex-shrink-0 border-white/20 bg-white/10 backdrop-blur-sm rounded-md p-2 shadow-lg">
              <Icon className="w-4 h-4 text-white" />
            </div>
            <div>
              <h3 className="text-white font-semibold text-sm mb-1">
                {feature.title}
              </h3>
              <p className="text-white/80 text-xs leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
